import { createFeatureSelector, createSelector } from '@ngrx/store';
import { YoutubeState } from '@states/youtube/youtube.reducer';

const selectYoutubeState = createFeatureSelector<YoutubeState>('youtubeState');

export const selectInitialLoaded = createSelector(selectYoutubeState, ({ initialLoaded }: YoutubeState) => initialLoaded);
export const selectNotEmpty = createSelector(selectYoutubeState, ({ notEmpty }: YoutubeState) => notEmpty);
export const selectIsSaving = createSelector(selectYoutubeState, ({ isSaving }: YoutubeState) => isSaving);
export const selectYoutubeList = createSelector(selectYoutubeState, ({ entities }: YoutubeState) => entities);

export const selectToRemoveList = createSelector(selectYoutubeState, ({ toRemove }: YoutubeState) => toRemove);
